import TKHeader from '@tk/components/tk.header';
import TKViewport from '@tk/basics/tk.viewport';
import TKSearch from '@tk/controls/tk.search';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import TKBasketButton from '@tk/components/tk.basket.button';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKCompareInfo from '@tk/components/compare/tk.compare.info';
import TKTabsTab from '@tk/controls/tk.tabs.tab';
import TKRequestManager from '@tk/basics/tk.request.manager';
import TKMinibasket from '@tk/components/tk.minibasket';

export const headerComponents = [
    { name: 'tk-viewport', constructor: TKViewport },
    { name: 'tk-request-manager', constructor: TKRequestManager },
    { name: 'tk-header', constructor: TKHeader },
    { name: 'tk-search', constructor: TKSearch },
    { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
    { name: 'tk-basket-button', constructor: TKBasketButton },
    { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
    { name: 'tk-compare-info', constructor: TKCompareInfo },
    { name: 'tk-tabs-tab', constructor: TKTabsTab },
    { name: 'tk-minibasket', constructor: TKMinibasket },
];
